/**
 * @author       david.loehr@zumper.com (David Loehr)
 * @copyright    Copyright (c) 2025, Zumper
 */

import type { Geo } from '@zcode/state-type'
import { createAction } from 'redux-actions'
import { GET_GEOS_SUCCESS } from './constants'

export const receiveGeos = createAction<Geo, typeof GET_GEOS_SUCCESS>(GET_GEOS_SUCCESS)
